import { render } from "./ZirconReport.vue?vue&type=template&id=3d4d3364&scoped=true"
import script from "./ZirconReport.vue?vue&type=script&lang=js"
export * from "./ZirconReport.vue?vue&type=script&lang=js"

import "./ZirconReport.vue?vue&type=style&index=0&id=3d4d3364&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d4d3364"]])

export default __exports__